
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

interface UserCardView {
  firstname: string;
  lastname: string;
  email: string;
  mobile: string;
  address: string;
}
export default defineComponent({
  props: {
    data: {
      type: Object,
      default: function (): UserCardView {
        return {} as UserCardView;
      },
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
